import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { BasketSummaryDetailsStyled } from '../BasketSummaryDetailsStyled';
import { rem } from 'polished';

export const BasketSummaryDetailsOV = styled(BasketSummaryDetailsStyled)`
    .title {
        font-size: ${({ theme }) => theme.fontSizes.textBig};
        background: ${({ theme }) => theme.colors.grey10};

        @media (max-width: ${breakpoints.md}px) {
            background: none;
        }
    }

    .storePrice {
        &_value_price {
            width: ${rem(180)};
            text-align: right;
        }
    }

    .totalPrice {
        &_monthlyPrice {
            font-size: ${rem(20)};
        }

        &_label {
            .promotionalTextWrapper {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }

    .pxSection {
        background: ${({ theme }) => theme.colors.pureWhite};

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};

            .link {
                svg {
                    width: ${rem(20)};
                    height: ${rem(20)};
                    margin-bottom: ${rem(-4)};
                }
            }
        }
        &_status {
            &__label {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                line-height: ${rem(20)};
            }
        }
    }

    .promoCodeSection {
        .promoCode {
            &__input {
                border-color: ${({ theme }) => theme.colors.pureWhite};
            }

            &__input_container {
                border: 1px solid ${({ theme }) => theme.colors.black};
            }
        }
    }

    .infoIcon {
        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.black};
                    stroke: none;
                }
                path {
                    fill: ${({ theme }) => theme.colors.pureWhite};
                }
            }

            path {
                fill: unset;
            }
        }
    }

    .wallboxSection {
        background: ${({ theme }) => theme.colors.pureWhite};

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
        }
    }

    .continueSection {
        background: ${({ theme }) => theme.colors.grey10};
    }
`;
